import React from 'react';
import './index.scss';
import AllReviews from 'views/AllCourses/AllReviews';
export default function ReviewSection() {
    return (
        <div className={'about-section'}>
            <AllReviews/>
        </div>
    );
}